import behance from "../../../assets/images/Posts/1/SVG color socials/Behance.svg";
import fb from "../../../assets/images/Posts/1/SVG color socials/Facebook.svg";
import insta from "../../../assets/images/Posts/1/SVG color socials/Instagram.svg";
import LinkedIn from "../../../assets/images/Posts/1/SVG color socials/LinkedIn.svg";
import mailru from "../../../assets/images/Posts/1/SVG color socials/Mail.ru.svg";
import messenger from "../../../assets/images/Posts/1/SVG color socials/Messenger.svg";
import ok from "../../../assets/images/Posts/1/SVG color socials/Ok.svg";
import pinterest from "../../../assets/images/Posts/1/SVG color socials/Pinterest.svg";
import skype from "../../../assets/images/Posts/1/SVG color socials/Skype.svg";
import snapchap from "../../../assets/images/Posts/1/SVG color socials/Snapchat.svg";
import soundCloud from "../../../assets/images/Posts/1/SVG color socials/SoundCloud.svg";
import spotify from "../../../assets/images/Posts/1/SVG color socials/Spotify.svg";
import telegram from "../../../assets/images/Posts/1/SVG color socials/Telegram.svg";
import tiktok from "../../../assets/images/Posts/1/SVG color socials/TikTok.svg";
import tumblr from "../../../assets/images/Posts/1/SVG color socials/Tumblr.svg";
import twitch from "../../../assets/images/Posts/1/SVG color socials/Twitch.svg";
import twitter from "../../../assets/images/Posts/1/SVG color socials/Twitter.svg";
import viber from "../../../assets/images/Posts/1/SVG color socials/Viber.svg";
import vimeo from "../../../assets/images/Posts/1/SVG color socials/Vimeo.svg";
import vk from "../../../assets/images/Posts/1/SVG color socials/VK.svg";
import wechat from "../../../assets/images/Posts/1/SVG color socials/WeChat.svg";
import whatsup from "../../../assets/images/Posts/1/SVG color socials/WhatsApp.svg";
import youtube from "../../../assets/images/Posts/1/SVG color socials/YouTube.svg";
import zen from "../../../assets/images/Posts/1/SVG color socials/Zen.svg";

export const socials = [
  vk, fb, insta, LinkedIn, mailru, telegram, messenger, ok, viber, skype, whatsup, youtube,
  tiktok, twitch, twitter, snapchap, soundCloud, spotify, tumblr, pinterest, vimeo,
  behance, wechat, zen
];
